import { render, staticRenderFns } from "./AuthPasswordReset.vue?vue&type=template&id=047c2e1b"
import script from "./AuthPasswordReset.vue?vue&type=script&lang=js"
export * from "./AuthPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports